<template>
  <div>
    <div class="card" id="widget_bauprojekte">
      <div class="loader-container" v-if="updating">
        <Loader />
        <div class="loader-message">
          Lade Bauprojekte
        </div>
      </div>

      <div class="card-body" v-if="!updating">
        <div class="headline">
          <router-link :class="{ disabled: !updating }" class="no-link-decoration" :to="{ name: 'admin-bauprojekte' }">
            <h4>Bauprojekte</h4>
          </router-link>
        </div>
        <transition :name="anim.standard.name" :enter-active-class="anim.standard.enter" :leave-active-class="anim.standard.leave">
          <div class="table-responsive datatable-vue table-scroll" v-if="sort_rdy">
            <b-table show-empty :items="cron_bauprojekte" :fields="tablefields.cron_bauprojekte">
              <template v-slot:cell(free)="row">
                <div class="iam-count-wohnungen">{{getBookedWohnungen(row.item.id)}} / {{getFreeWohnungenMax(row.item.id)}} </div>
                <b-progress
                  class="sm-progress-bar progress-in-table iam-progress"
                  :max="getFreeWohnungenMax(row.item.id)"
                  :value="getBookedWohnungen(row.item.id)"
                ></b-progress>
                
              </template>
              <template v-slot:cell(link)="row">
                <feather type="edit-2" class="infra-blue pointer" @click="$router.push('/admin/dashboard/bauprojekte/' + row.item.id)"></feather>
              </template>
              <template slot="empty"><div class="text-center">Keine Bauprojekte gefunden.</div></template>
            </b-table>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Loader from "@/components/LoaderRelative.vue";

export default {
  name: "WidgetAdminBauprojekte",
  data() {
    return {
      cron_bauprojekte: [],
      sort_rdy: false,
      updating: false,
      tablefields: {
        cron_bauprojekte: [
          { key: "name", label: "Name", sortable: false },
          { key: "free", label: "Belegung", sortable: false },
          { key: "link", label: "Optionen", sortable: false },
        ],
      },
    };
  },
  components: {
    Loader,
  },
  computed: {
    ...mapGetters({
      bauprojekte: "app/bauprojekte",
      ready: "app/readyState",
      toasts: "app/toasts",
      anim: "app/animations",
    }),
  },
  created: async function() {
    if (this.bauprojekte == false) {
      try {
        this.updating = true;
        await this.$store.dispatch("app/apiGetBauprojekte");
      } catch (error) {
        console.log(error);
      } finally {
        this.updating = false;
      }
    }

    //assign and sort bauprojekte to display
    this.cron_bauprojekte = this.cloneNonReactive(this.bauprojekte);
    this.cron_bauprojekte.sort(function(a, b) {
      let aDate = new Date(a.created_on);
      let bDate = new Date(b.created_on);
      return aDate - bDate;
    });
    this.sort_rdy = true;
  },
  methods: {
    getFreeWohnungenMax: function(bpId) {
      const bp = this.bauprojekte.find((b) => {
        return b.id == bpId;
      });
      if ("undefined" == typeof bp.extended.hauser) return;
      let resultAllWohnungen = 0;
      bp.extended.hauser.forEach((h) => {
        if ("undefined" == typeof h.extended.wohnungen) return;
        resultAllWohnungen = resultAllWohnungen + h.extended.wohnungen.length;
      });
      return resultAllWohnungen;
    },
    getBookedWohnungen: function(bpId) {
      const bp = this.bauprojekte.find((b) => {
        return b.id == bpId;
      });
      let resultBooked = 0;
      bp.extended.hauser.forEach((h) => {
        if ("undefined" == typeof h.extended.wohnungen) return;
        h.extended.wohnungen.forEach((w) => {
          if (w.status == "verfügbar") return;
          resultBooked++;
        });
      });
      return resultBooked;
    },
  },
};
</script>

<style scoped>
.loader-relative {
  background: none;
  backdrop-filter: none;
}

.iam-count-wohnungen {
  margin:auto;
  display:block;
}

</style>
